























  import {Component, Vue} from 'vue-property-decorator';
  import {clearStorage} from '@/store/index.store';
  import * as Sentry from '@sentry/browser';
  import {Severity} from '@sentry/browser';

  @Component({
		components: {},
	})
  export default class ErrorPage extends Vue {

    created() {
      clearStorage();
      const errorMsg = `Page not found: '${this.fullPath}'`;
      Vue.$log.error(errorMsg);
      Sentry.captureMessage(errorMsg, Severity.Error);
    }

    get fullPath() {
      let fullPath: any = this.$route.query['fullPath'];
      if (!fullPath) {
        fullPath = this.$route.fullPath;
      }
      return fullPath;
    }

    get message() {
      return this.$route.query['message'];
    }

	}
